export default __webpack_public_path__ + "static/media/global-fullstack.30d4dc2f.png";